import React from 'react'
import { translate } from '../../utils/useful'


class OwnedRooms extends React.Component {
    state = {

        isLoader: false,
        currentPage: 'voice',

        videocalls: [
            // { icon: "/assets/icons/rooms/rejected.svg", color: "#FF3B30", name: "Class 101", creator: "Pouya Pezhman", date: "Today, 9:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "React Native class 234", creator: "Pouya Pezhman", date: "Yesterday, 5:25 PM" },
            // { icon: "/assets/icons/rooms/roomcall-gray.svg", color: "#444", name: "Math Elemntry 209", creator: "Pouya Pezhman", date: "3/5/23, 10:55 AM" },
        ],

    }

    componentDidMount() {

    }

    componentWillUnmount() {
    }


    showDate = (date) => {
        if (this.props.showDate) {
            return this.props.showDate(date, true)
        }
    }
    changePage = (data, page) => {
        this.props.setData('currentRoom', data, 'RoomsHome', () => {

            this.props.changePage(page)
        })
    }

    render() {
        return (
            <div className='flexcc' style={{}}>
                <div className='w-100 h-100'>
                    <div className=''>
                        {this.props.videocalls.map((prop, index) => {
                            return (
                                <div className='bb-gray hover-gray br-5'>
                                    <button className='flexcb w-100 py-2 px-2' onClick={() => this.changePage(prop, { key: 'info' })}>
                                        <div className='flexc'>
                                            <img className='mrd-2' src={prop.icon} />
                                            <div className='text-start'>
                                                <p className='weight-500 font-size-14' style={{ color: prop.color }}>{prop.title}</p>
                                                <p className='weight-300 font-size-10' style={{ color: '#777' }}>{prop.owner?.fullname}</p>
                                            </div>
                                        </div>
                                        <div className='flexc'>
                                            <p className='font-size-10' style={{ color: '#777' }}>{this.showDate(prop.cDate)}</p>
                                            <button className='flexcc'>
                                                <img className='mld-3' src='/assets/icons/rooms/more-purple.svg' />
                                            </button>
                                        </div>
                                    </button>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }
}

export default OwnedRooms;